exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-dialog-modal-operation-area-2QHX-{display:flex;margin:10px 0;padding-left:10px}", ""]);

// Exports
exports.locals = {
	"dialog-modal-operation-area": "style-dialog-modal-operation-area-2QHX-"
};